import { dirname } from 'path'
import { merge } from 'theme-ui'

import {
  resolveFontFamily,
  resolveThemeUIFontSizes,
} from '@jotta/ui/FontConfig'

import type { BrandTheme, PartialBrandTheme } from '../../types/BrandTheme'
import { brandTheme } from '../../types/BrandTheme'

import './theme.css'

export const tskytheme: BrandTheme = merge.all<BrandTheme, PartialBrandTheme>(
  brandTheme,
  {
    branding: {
      brand: 'TDC_NO',
      themedir: dirname(new URL(import.meta.url).pathname),
      staticDir: 'tsky',
      height: 40,
    },
    radii: [0, 4, 5, 10],
    fontSizes: resolveThemeUIFontSizes('tsky'),
    fonts: resolveFontFamily('tsky'),
    colors: {
      accent: '#666870',
      accentText: '#fff',
      background: '#fff',
      border: '#E9E9E9',
      danger: '#EF3138',
      muted: '#f9f9f9',
      primary: '#2B2B2B',
      primaryText: 'white',
      focus: '#2B2B2B',
      focusDark: '#666870',
      text: '#333',
      grayBg: '#58585B',
      lightBlueBg: '#4990E2',
      slateBlackBg: '#241F24',
      slateGray: '#505050',
      warningText: '#333',
      gray: '#928d89',
      darkGray: '#232323',
      tSkyTeal: '#00B6CA',
    },
    buttons: {
      primary: {
        backgroundColor: '#00B6CA',
        borderRadius: '2px',
        fontWeight: 'light',
        border: '1px solid #DDDDDE',
        '&:not(:disabled):hover': {
          backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.4) 0 0)',
          opacity: 1,
          filter: 'brightness(1)',
        },
      },
      secondary: {
        variant: 'buttons.primary',
        color: 'grayBg',
        '&:not(:disabled):hover': {
          filter: 'brightness(0.9)',
          opacity: 0.9,
        },
      },
      danger: {
        color: '#ef3138',
      },
      replyButton: {
        color: 'var(--color-primary)',
      },
      replyButtonDarkMode: {
        color: 'background',
      },
    },
    cards: {
      photoUploadSuccess: {
        '--action-button-color': '#fff',
        '--action-button-text-opacity': 1,
        backgroundColor: 'slateGray',
      },
      photoUpload: {
        '--action-button-text-opacity': 1,
      },
    },
    forms: {
      input: {
        fontFamily: 'body',
        fontWeight: 'body',
        fontSize: 2,
        color: 'black',
        ':focus': { borderBottomColor: 'lightBlueBg' },
      },
      toggle: {
        '&:checked::before': {
          backgroundColor: 'slateBlackBg',
        },
        '&:checked::after': {
          backgroundColor: 'slateBlackBg',
        },
      },
      checkbox: {
        fontSize: '11px',
        borderRadius: '3px',
        border: '1px solid',
      },
    },
    layout: {
      appHeader: {
        backgroundColor: 'background',
      },
      appHeaderHamburger: {
        color: 'black',
        opacity: 0.9,
        '& > svg': {
          '&:hover': {
            color: 'warningText',
            opacity: 1,
          },
        },
      },
    },
    styles: {
      h1: {
        fontWeight: 500,
        color: 'grayHeading',
        fontSize: '23px',
      },
      h2: {
        fontSize: '17px',
        fontWeight: 500,
        margin: '0 0 20px',
        padding: 0,
        color: 'graySlateBgColor',
      },
      h4: {
        color: 'warningText',
      },
      p: {
        color: 'graySlateOpacityBg',
        fontSize: 2,
      },
      boldParagraphStyle: {
        fontWeight: 'heading',
        fontSize: 2,
        color: 'graySlateOpacityBg',
      },
      tr: {
        color: 'graySlateOpacityBg',
      },
      downloadPageHeader: {
        color: 'black',
      },
      subHeaderText: {
        fontSize: ['19px', '21px', '24px'],
      },
      downloadSvg: {
        color: '#00b6ca',
      },
      fileinfo: {
        fontWeight: 300,
      },
      addMoreSvg: {
        color: 'tSkyTeal',
        fontSize: 5,
      },
    },
  },
)
export default tskytheme
